import { IconProps } from ".";
import Icon from "./assets/money_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Money(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
